// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';

if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}

import { Router } from '@thepassle/app-tools/router.js';
import { lazy } from '@thepassle/app-tools/router/plugins/lazy.js';

// @ts-ignore
import { title } from '@thepassle/app-tools/router/plugins/title.js';

import './pages/web-home.js';

const baseURL: string = (import.meta as any).env.BASE_URL;

export const router = new Router({
    routes: [
      {
        path: resolveRouterPath(),
        title: 'Home',
        render: () => html`<web-home></web-home>`
      },
      {
        path: resolveRouterPath('videopodcast'),
        title: 'Video Podcasts',
        plugins: [
          lazy(() => import('./pages/video-podcast.js')),
        ],
        render: () => html`<video-podcast></video-podcast>`
      },
      {
        path: resolveRouterPath('courses/choosing-right-property'),
        title: 'Course: Choosing The Right Property',
        plugins: [
          lazy(() => import('./pages/courses/choosing-right-property.js')),
        ],
        render: () => html`<choosing-right-property></choosing-right-property>`
      },
      {
        path: resolveRouterPath('comingsoon'),
        title: 'Coming Soon',
        plugins: [
          lazy(() => import('./pages/coming-soon.js')),
        ],
        render: () => html`<coming-soon></coming-soon>`
      }

    ]
  });

  // This function will resolve a path with whatever Base URL was passed to the vite build process.
  // Use of this function throughout the starter is not required, but highly recommended, especially if you plan to use GitHub Pages to deploy.
  // If no arg is passed to this function, it will return the base URL.

  export function resolveRouterPath(unresolvedPath?: string) {
    var resolvedPath = baseURL;
    if(unresolvedPath) {
      resolvedPath = resolvedPath + unresolvedPath;
    }
		console.log('resolvedPath', resolvedPath, 'unresolvedPath', unresolvedPath);
    return resolvedPath;
  }
